<template>
  <div>
    <!-- Name -->
    <div class="row">
      <div class="col-12">
        <div class="label mt-2 mb-1">Name</div>
        <input type="text" class="form-control" v-model="occurrence.name" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="label mt-2 mb-1">Diverted Flight</div>
        <button
          v-if="!divertedFlight"
          type="button"
          :disabled="addFlightsLoading"
          class="btn btn-block btn-sm btn-success mt-2 mb-2 d-flex justify-content-center align-items-center"
          @click="chooseDivertedFlight()"
        >
          <i class="far fa-plus mr-2" v-if="!addFlightsLoading"></i>
          <i class="far fa-spinner fa-spin mr-2" v-else></i>
          Choose Diverted Flight
        </button>
      </div>
    </div>

    <div v-if="divertedFlight">
      <table class="aog-table table table-striped">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col style="width: 80px" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Flight</th>
            <th scope="col">Operator</th>
            <th scope="col">Type</th>
            <th scope="col">Registration</th>
            <th scope="col">Departure</th>
            <th scope="col">Arrival</th>
            <th scope="col">Diverted To</th>
            <th scope="col" class="col-date">STD</th>
            <th scope="col" class="col-date">STA</th>
            <th scope="col">State</th>
            <th scope="col" class="remove-col"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="" v-for="flight in occurrence.flights" :key="flight.id">
            <td>{{ flight.date | formatDateWithoutHours }}</td>
            <td>{{ flight.flightNo }}</td>
            <td>{{ flight.operator }}</td>
            <td>{{ flight.aircraftType }}</td>

            <td>{{ flight.aircraftRegistration }}</td>

            <td>{{ flight.departureAirport }}</td>
            <td>{{ flight.arrivalAirport }}</td>
            <td>
              <v-select
                style="width: 90px"
                :options="airports"
                label="iataCode"
                :clearable="false"
                :reduce="(airport) => airport.iataCode"
                placeholder="Select..."
                v-model="divertedFlight.diversionAirport"
                :disabled="occurrence.isCompleted || !userCanEdit"
              ></v-select>
            </td>

            <td>{{ flight.scheduledTimeOfDeparture | formatTime }}</td>
            <td>{{ flight.scheduledTimeOfArrival | formatTime }}</td>

            <td>{{ flight.flightState }}</td>
            <td>
              <i
                v-if="!occurrence.isCompleted && userCanEdit"
                class="so-flight-remove far fa-trash-alt cursor-pointer"
                v-b-tooltip.hover="'Remove flight'"
                v-on:click="removeFlight(flight)"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="divertedFlight">
      <!-- Aircraft && Airport -->
      <div class="row">
        <div class="col-4">
          <div class="mt-2 mb-2 p-1">
            <div class="label">
              Original Destination Info
              <a :href="stationInfo.sisPdfUrl" target="_blank">
                <i class="far fa-link"></i>
                SIS
              </a>
            </div>

            <div class="row mb-2">
              <div class="col-2">MRO</div>
              <div class="col-10">
                {{ stationInfo.mro || 'N/A' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="mt-2 mb-2 p-1">
            <div class="label">
              Diversion Destination Info
              <a :href="stationInfoDiv.sisPdfUrl" target="_blank">
                <i class="far fa-link"></i>
                SIS
              </a>
            </div>

            <div class="row mb-2">
              <div class="col-2">MRO</div>
              <div class="col-10">
                {{ stationInfoDiv.mro || 'N/A' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="label mt-2 mb-1">Diversion Reason</div>
          <v-select
            :options="diversionReasons"
            label="name"
            :clearable="false"
            :reduce="(reason) => reason.id"
            placeholder="Please select a Reason..."
            v-model="occurrence.diversionReason"
            :disabled="occurrence.isCompleted || !userCanEdit"
          ></v-select>
        </div>
      </div>

      <div class="row" v-if="displayDiversionReasonRemarks">
        <div class="col-12">
          <div class="label mt-2 mb-1">Diversion Reason Remarks</div>
          <textarea-autosize
            class="form-control comment-textarea"
            style="padding-right: 30px"
            rows="3"
            placeholder=""
            v-model="occurrence.diversionReasonRemarks"
            :min-height="75"
            :disabled="occurrence.isCompleted || !userCanEdit"
          ></textarea-autosize>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-6">
          <div class="label mt-2 mb-1 d-flex justify-content-between align-items-center">
            <div>Diversion Start</div>
          </div>
          <board-item-date-picker
            :disabled="occurrence.isCompleted || !userCanEdit"
            v-model="occurrence.diversionStart"
          ></board-item-date-picker>
        </div>
        <div class="col-6">
          <div class="label mt-2 mb-1 d-flex justify-content-between align-items-center">
            <div>Diversion End (Estimated)</div>
          </div>
          <board-item-date-picker
            :disabled="occurrence.isCompleted || !userCanEdit"
            v-model="occurrence.diversionEndEstimated"
          ></board-item-date-picker>
        </div>
      </div>

      <div>
        <div class="label mt-2 mb-1">General remarks</div>
        <textarea-autosize
          class="form-control comment-textarea"
          style="padding-right: 30px"
          rows="3"
          placeholder=""
          v-model="occurrence.generalRemarks"
          :min-height="75"
          :disabled="occurrence.isCompleted || !userCanEdit"
        ></textarea-autosize>
      </div>
    </div>
    <hr />
    <div class="mt-2 justify-content-end d-flex" v-if="!occurrence.isCompleted">
      <div>
        <button class="btn btn-block btn-sm btn-success mt-2 mb-3" @click="saveChanges()">
          <i class="far fa-save"></i>
          Save Changes
        </button>
      </div>
    </div>

    <b-modal
      ref="addFlights"
      id="addFlights"
      body-class="modal-body-wo"
      hide-footer
      hide-header
      size="wide"
      title="Add Affected Flight"
      :no-enforce-focus="true"
    >
      <TechnicalOccurrenceFlightsSelector
        @flightSelected="flightSelected"
        @closeModal="closeModal"
        :mode="'diversion'"
      ></TechnicalOccurrenceFlightsSelector>
    </b-modal>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import {
    AircraftDto,
    AirportDto,
    DiversionDto,
    FlightInfoDto,
    SpecialOccurrenceAccessLevel,
    SpecialOccurrenceFlightInsertDto,
  } from '@/apiclient/apiclient_generated';
  import { Prop } from 'vue-property-decorator';
  import { GlobalHelper } from '@/helpers/global-helper';
  import TechnicalOccurrenceFlightsSelector from '@/components/SpecialOccurrence/Data/Flights/TechnicalOccurrenceFlightsSelector.vue';

  @Component({
    components: { TechnicalOccurrenceFlightsSelector },
  })
  export default class DiversionData extends Vue {
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    @Prop() occurrence: DiversionDto;
    showChooseFlightModal = false;
    addFlightsLoading = false;

    async mounted() {
      await this.store.loadDiversionReasons();
    }

    get divertedFlight(): FlightInfoDto {
      if (!this.occurrence.flights || !this.occurrence.flights[0]) {
        return null;
      }

      return this.occurrence.flights[0];
    }

    get stationInfo(): AirportDto {
      if (!this.divertedFlight) return AirportDto.fromJS({});

      return (
        this.store.airports.find((_) => _.iataCode.toLowerCase() === this.divertedFlight.departureAirport.toLowerCase()) || new AirportDto()
      );
    }

    get stationInfoDiv(): AirportDto {
      if (!this.divertedFlight || !this.divertedFlight.diversionAirport) return AirportDto.fromJS({});

      return (
        this.store.airports.find((_) => _.iataCode.toLowerCase() === this.divertedFlight.diversionAirport.toLowerCase()) || new AirportDto()
      );
    }

    get aircraftInfo(): AircraftDto {
      return this.store.aircrafts.find((_) => _.id == this.occurrence.aircraft) || new AircraftDto();
    }

    get airports() {
      return this.store.airports;
    }

    get aircrafts() {
      return this.store.aircrafts;
    }

    get diversionReasons() {
      return this.store.diversionReasons;
    }

    get userCanEdit(): boolean {
      return (
        this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Admin ||
        this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Editor
      );
    }

    get displayDiversionReasonRemarks(): boolean {
      const reason = this.diversionReasons.find(_=>_.id == this.occurrence.diversionReason);

      return reason?.isOther;
    }

    async chooseDivertedFlight() {
      this.addFlightsLoading = true;

      await this.store.saveOccurrenceDataChanges(this.occurrence);
      await this.store.getDiversionFlights();

      this.addFlightsLoading = false;

      const modal: any = this.$refs['addFlights'];
      modal.show();
    }

    closeModal() {
      const modal: any = this.$refs['addFlights'];
      modal.hide();
    }

    async saveChanges() {
      await this.store.saveOccurrenceDataChanges(this.occurrence);
      GlobalHelper.NotifySuccess('Special Occurrence updated');
      await this.store.loadData();
    }

    async flightSelected(flight) {
      this.store.currentOccurrence.flights = [];
      this.store.currentOccurrence.flights = [flight];

      const dto = {
        occurrenceId: this.occurrence.id,
        flights: this.store.currentOccurrence.flights,
      } as SpecialOccurrenceFlightInsertDto;

      await this.store.saveOccurrenceFlights(dto);

      GlobalHelper.NotifySuccess('Diverted Flight selected');
    }

    async removeFlight() {
      this.store.currentOccurrence.flights = [];
      const dto = {
        occurrenceId: this.occurrence.id,
        flights: this.store.currentOccurrence.flights,
      } as SpecialOccurrenceFlightInsertDto;

      await this.store.saveOccurrenceFlights(dto);
    }
  }
</script>

<style lang="scss" scoped>
  .aog-table {
    td {
      vertical-align: middle;
    }
  }
</style>
